// Assistant chats are excluded too: autocapture would record questions and,
// on the scout assistant, the athlete names rendered in the answers.
const PRIVATE_AUTH_PATH = /\/(?:verify-email|reset-password|guardian\/verify|athlete\/assistant|scout\/assistant)(?:\/|$)/i;

export function isPrivateAuthPage(href = window.location.href) {
  try {
    const url = new URL(href, window.location.origin);
    const hashPath = decodeURIComponent(url.hash.replace(/^#/, "")).split("?")[0];
    return PRIVATE_AUTH_PATH.test(decodeURIComponent(url.pathname)) || PRIVATE_AUTH_PATH.test(hashPath);
  } catch { return true; }
}

const PRIVATE_PARAMS = new Set(["token", "access_token", "refresh_token", "question"]);

const redactQueryTokens = text => text.replace(
  /([?&#])([^=?&#\s"<>]+)=([^&#\s"<>]*)/g,
  (match, separator, name) => {
    try {
      return PRIVATE_PARAMS.has(decodeURIComponent(name).toLowerCase())
        ? `${separator}${name}=[redacted]` : match;
    } catch { return match; }
  },
);

function sanitizeAnalyticsString(value) {
  let safe = redactQueryTokens(value);
  let candidate = safe;
  // Retained SDK properties may contain encoded URLs, including encoded names.
  // Decode only for inspection; preserve unrelated strings and their spelling.
  for (let i = 0; i < 3; i++) {
    let decoded;
    try { decoded = decodeURIComponent(candidate); } catch { break; }
    if (decoded === candidate) break;
    const redacted = redactQueryTokens(decoded);
    if (redacted !== decoded) safe = redacted;
    candidate = redacted;
  }
  return safe;
}

// Apply at the outgoing SDK boundary, including retained/referrer/session URLs.
// Preserve SDK Date metadata so its request queue can calculate event offsets.
export function sanitizeAnalyticsValue(value) {
  if (typeof value === "string") return sanitizeAnalyticsString(value);
  if (Array.isArray(value)) return value.map(sanitizeAnalyticsValue);
  if (value instanceof URL) return new URL(sanitizeAnalyticsString(value.href));
  if (value && typeof value === "object") {
    const prototype = Object.getPrototypeOf(value);
    if (prototype !== Object.prototype && prototype !== null) return value;
    return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, sanitizeAnalyticsValue(item)]));
  }
  return value;
}

export function filterAuthLinkAnalyticsEvent(event) {
  if (isPrivateAuthPage()) return null;
  return sanitizeAnalyticsValue(event);
}
